import React from 'react';
import styles from '../styles.module.css';
import { stat } from '@/commonTypes';

export default function StatsComponent({ stats = [] }: { stats?: stat[] }) {
  return (
    <div className={styles.statStrip}>
      <div className={styles.stats}>
        {stats?.map((s, index) => (
          <div key={index} className={styles.stat}>
            <div className={styles.statValue}>{s.v}</div>
            <div className={styles.statLabel}>{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
